import { toggle_off, toggle_on } from "../../../assets/img";


export const bar_chart = [
  {
    label: "January",
    value: 200,
  },
  {
    label: "February",
    value: 45,
  },
  {
    label: "March",
    value: 300,
  },
  {
    label: "April",
    value: 100,
  },
  {
    label: "May",
    value: 150,
  },
  {
    label: "June",
    value: 210,
  },
  {
    label: "July",
    value: 120,
  },
  {
    label: "August",
    value: 140,
  },
]

export const admin_list = [
  {
    id: 1,
    name: "RamKumar",
    role: "Super Admin",
    user: "Aravind",
    email: "ramkumar@gmail.com",
    password: "Ramkumar",
    status: "Approved",
    propertyStatus: 1,
    type: "Bank",
    number: "9878098077",
    toggle: "on",
    deviceId: "KW-038",
    client: "Device1",
    assigned: "Sathish",
    location: "Hyderabad",
    city: "Chennai",
    propertyName: "Enistin",
    propertyId: "AI002",
    propertyType: "Room",
    propName: "Masters - Property Content",
    age: "28",
    time: "01:20 PM",
    imageCount: "5",
    fromDate: "15-03-2025",
    lot: "Dear",
    lot_num: "2343",
    details: {
      message: {
        text: "SINGLE DIGIT 3650 B",
        time: "DEAR 1:30PM",
      },
    },
    price_details: {
      message: {
        text: "SINGLE DIGIT B",
        time: "",
      },
    },
    prize: "12",
    approved: "No",
    balance: "₹1,22,222",
    action: "thumb",
    trans: "234567543221",
    qty: "32",
    repStatus: "Pending",
    withStatus: "Pending",
    winStatus: "Not Paid",
    amount: "₹ 2000",
    commission: "₹ 2000",
    toDate: "16-03-2025",
    category: "Villa",
    country: "India",
    state: "TamilNadu",
    RoomBlock: "Block",
    desc: "Embark on your web creation journey with our Bootstrap contact us template, seamlessly combined with AI capabilities",
  },
  {
    id: 2,
    name: "Varun",
    role: "Admin",
    user: "Varun",
    email: "varun@gmail.com",
    password: "Varun",
    status: "off",
    propertyStatus: 2,
    winStatus: " Paid",
    withStatus: "Transferred",
    type: "UPI",
    number: "9435098077",
    lot: "Kerala",
    lot_num: "2343",
    time: "01:20 PM",
    details: {
      message: {
        text: "SINGLE DIGIT 3650 B",
        time: "DEAR 1:30PM",
      },
    },
    price_details: {
      message: {
        text: "SINGLE DIGIT B",
        time: "",
      },
    },
    prize: "12",
    qty: "32",
    approved: "Yes",
    balance: "₹1,22,222",
    action: "thumb",
    trans: "234567543221",
    repStatus: "ANNOUNCED",
    toggle: "off",
    status: "Pending",
    deviceId: "KW-058",
    client: "Device2",
    assigned: "Sambath",
    location: "Madurai",
    city: "Tambaram",
    propertyName: "Kudan",
    propertyId: "CH005",
    propertyType: "Individual",
    propName: "House Rules",
    age: "30",
    imageCount: "5",
    fromDate: "15-03-2025",
    amount: "₹ 2000",
    commission: "₹ 2000",
    toDate: "16-03-2025",
    category: "Resort",
    country: "India",
    state: "TamilNadu",
    RoomBlock: "Block",
    desc: "Embark on your web creation journey with our Bootstrap contact us template, seamlessly combined with AI capabilities",
  },
  {
    id: 3,
    name: "Johan",
    role: "Admin",
    user: "Johan",
    email: "johan@gmail.com",
    time: "01:20 PM",
    password: "Johan",
    type: "Bank",
    number: "9878098077",
    toggle: "on",
    lot: "Dear",
    lot_num: "2343",
    details: {
      message: {
        text: "SINGLE DIGIT 3650 B",
        time: "DEAR 1:30PM",
      },
    },
    price_details: {
      message: {
        text: "SINGLE DIGIT B",
        time: "",
      },
    },
    prize: "12",
    withStatus: "Pending",
    qty: "32",
    approved: "No",
    balance: "₹1,22,222",
    action: "thumb",
    trans: "234567543221",
    repStatus: "Pending",
    winStatus: "Not Paid",
    status: "Approved",
    propertyStatus: 3,
    deviceId: "KW-738",
    client: "Device3",
    assigned: "Aravindh",
    location: "Banglore",
    city: "Chennai",
    propertyName: "Enistin",
    propertyId: "AI004",
    propertyType: "Room",
    propName: "Safety & Property",
    age: "35",
    imageCount: "5",
    fromDate: "15-03-2025",
    amount: "₹ 2000",
    commission: "₹ 2000",
    toDate: "16-03-2025",
    category: "Villa",
    country: "India",
    state: "TamilNadu",
    RoomBlock: "Block",
    desc: "Embark on your web creation journey with our Bootstrap contact us template, seamlessly combined with AI capabilities",
  },
  {
    id: 4,
    name: "Sathish",
    role: "Admin",
    user: "Sathish",
    email: "sathish@gmail.com",
    password: "Sathish",
    type: "Mobile",
    number: "9888098077",
    lot: "Kerala",
    lot_num: "2343",
    details: {
      message: {
        text: "SINGLE DIGIT 3650 B",
        time: "DEAR 1:30PM",
      },
    },
    price_details: {
      message: {
        text: "SINGLE DIGIT B",
        time: "",
      },
    },
    prize: "12",
    qty: "32",
    approved: "Yes",
    balance: "₹1,22,222",
    action: "thumb",
    withStatus: "Transferred",
    trans: "234567543221",
    time: "01:20 PM",
    toggle: "off",
    status: "Pending",
    repStatus: "ANNOUNCED",
    winStatus: " Paid",
    propertyStatus: 1,
    deviceId: "KW-838",
    client: "Device4",
    assigned: "Nivin",
    location: "Chennai",
    city: "Tambaram",
    propertyName: "Kudan",
    propertyId: "CH002",
    propertyType: "Individual",
    propName: "House Rules",
    age: "32",
    imageCount: "5",
    fromDate: "15-03-2025",
    amount: "₹ 2000",
    commission: "₹ 2000",
    toDate: "16-03-2025",
    category: "Resort",
    country: "India",
    state: "TamilNadu",
    RoomBlock: "Block",
    desc: "Embark on your web creation journey with our Bootstrap contact us template, seamlessly combined with AI capabilities",
  },


];

export const datas = [
  {
    id: 1,
    name: "hari",
    number: "9898344343",
    role: "admin",
  },
  {
    id: 1,
    name: "hari",
    number: "9898344343",
    role: "admin",
  },
  {
    id: 1,
    name: "hari",
    number: "9898344343",
    role: "admin",
  },
  {
    id: 1,
    name: "hari",
    number: "9898344343",
    role: "admin",
  },
  {
    id: 1,
    name: "hari",
    number: "9898344343",
    role: "admin",
  },
  {
    id: 1,
    name: "hari",
    number: "9898344343",
    role: "admin",
  },
  {
    id: 1,
    name: "hari",
    number: "9898344343",
    role: "admin",
  },
  {
    id: 1,
    name: "hari",
    number: "9898344343",
    role: "admin",
  },
  {
    id: 1,
    name: "hari",
    number: "9898344343",
    role: "admin",
  },
  {
    id: 1,
    name: "hari",
    number: "9898344343",
    role: "admin",
  },
]

